import { createTheme } from "@mui/material";

const theme = createTheme({
    direction : 'rtl',
    typography: {
      fontFamily: 'font-farsi'
    }
  });

  export default theme